export const CONTACT_SUPPORT_MODAL = 'CONTACT_SUPPORT_MODAL'
export const DELETE_CARD_CONFIRMATION_MODAL = 'DELETE_CARD_CONFIRMATION_MODAL'
export const LOG_IN_SIGN_UP_MODAL = 'LOG_IN_SIGN_UP_MODAL'
export const PAYMENT_METHOD_MODAL = 'PAYMENT_METHOD_MODAL'
export const USER_PROFILE_MODAL = 'USER_PROFILE_MODAL'
export const UPDATE_VERIFICATION_MODAL = 'UPDATE_VERIFICATION_MODAL'
export const UNSAVED_WORK_MODAL = 'UNSAVED_WORK_MODAL'
export const COOKIE_MODAL = 'COOKIE_MODAL'
export const WELCOME_MODAL = 'WELCOME_MODAL'
export const MUST_AGREE_MESSAGE =
  'You must agree to the above terms of service and privacy policy to place the order.'
